<template>
  <div>
    <q-dialog maximized :value="show" @hide="$emit('update:show', false)">
      <div class="vpage pc-width-pull-full">
        <!--Header-->
        <div class="vpage-header">
          <div class="vpage-header-back" @click="$emit('update:show', false)">
            <q-icon class="vpage-header-icon" name="svg:oback" />
          </div>
          <span class="vpage-header-title">{{
            $t('checkout.voucherDiscount')
          }}</span>
        </div>
        <!--Main-->
        <div class="vpage-main">
          <!--Search Bar-->
          <div class="vpage-main-searchbar">
            <q-input
              v-model="keyword"
              class="bar-input"
              outlined
              dense
              :placeholder="$t('checkout.searchHit')"
            />
          </div>
          <!--Body-->
          <div class="vpage-main-body">
            <template v-for="item of filterVoucherList">
              <VoucherItem
                v-if="item.showVoucher || isSearch"
                :key="item.id"
                :info="item"
                :curs="curVous"
                :keyword="keyword"
                @onChoose="onChoose"
                @onShowDetail="onShowDetail"
                @claim="$emit('claim')"
              />
            </template>
            <div v-if="loading" class="vpage-main-body-nodata">
              {{ $t('checkout.loading') }}
            </div>
            <div
              v-else-if="voucherList.length === 0"
              class="vpage-main-body-nodata"
            >
              {{ $t('checkout.emptyHit') }}
            </div>
            <div
              v-else-if="filterVoucherList.length === 0"
              class="vpage-main-body-nodata"
            >
              {{ $t('checkout.filterEmptyHit') }}
            </div>
          </div>
          <!--Footer-->
          <div class="vpage-main-footer">
            <div
              :class="['footer-btn', { none: isNoneBtn }]"
              @click="useVoucher()"
            >
              {{
                !isNoneBtn
                  ? $t('checkout.useVoucher')
                  : $t('checkout.continueWithoutPromo')
              }}
            </div>
          </div>
        </div>
      </div>
    </q-dialog>
    <!--DetailDialog-->
    <q-dialog
      v-model="detail.show"
      maximized
      @before-hide="detail = { ...detail, data: null, isLater: false }"
    >
      <div class="detail pc-width-pull-full">
        <div class="detail-head">
          <div class="detail-head-title">
            {{ $t('checkout.termsAndCondition') }}
          </div>
          <q-icon v-close-popup class="detail-head-close" name="svg:oclose" />
        </div>
        <div class="detail-main">
          <div class="detail-main-card">
            <div class="card-avatar">
              <img :src="detailInfo.avatar" alt="">
            </div>
            <div class="card-info">
              <span break bold class="name">{{
                detail.data && detail.data.name
              }}</span>
              <span break class="text">
                {{ $t('checkout.minTransaction') }}
                {{ $pid(detailInfo.minimumTransaction || 0) }}
              </span>
              <span v-if="detailInfo.paymentMethodAllowed" break class="text">
                {{ detailInfo.paymentMethodAllowed }}
              </span>
              <span class="text">
                {{ $t('checkout.until') }} {{ detailInfo.endDate }}
              </span>
            </div>
          </div>
          <ul class="detail-main-list">
            <li
              v-for="item of detailInfo.list"
              :key="item.key"
              class="list-item"
            >
              <i :class="`iconfont ${item.icon}`" />
              <div>
                <p bold class="key">{{ item.key }}</p>
                <p class="value">{{ item.value }}</p>
              </div>
            </li>
            <li class="list-item">
              <i class="iconfont dm-view-grid" />
              <div>
                <p bold class="key">{{ $t('checkout.promoOther') }}</p>
                <p class="value option">{{ detailInfo.timeStr }}</p>
                <p v-if="detailInfo.perCustomerStr" class="value option">
                  {{ detailInfo.perCustomerStr }}
                </p>
                <p v-if="detailInfo.promoEligibilityStr" class="value option">
                  {{ detailInfo.promoEligibilityStr }}
                </p>
                <p v-if="detailInfo.newCusomerOnly" class="value option">
                  {{ detailInfo.newCustomerOnly }}
                </p>
              </div>
            </li>
          </ul>
        </div>
        <div class="detail-footer">
          <div
            class="detail-footer-btn normal"
            :class="[{ disable: detailBtnDisable }]"
            style="width: 100%"
            @click="onChoose(detail.data)"
          >
            {{ detailBtnText }}
          </div>
        </div>
      </div>
    </q-dialog>
  </div>
</template>

<script>
import { random, xorBy } from 'lodash';
import { getVoucherList, reqDelVoucher } from 'src/api/checkout';
import { isDef, formatDate, useRetry } from 'src/utils/base';
import { reqRemoveCoupon } from 'src/api/fullDineIn';
import VoucherItem from './VoucherItem.vue';

export default {
  components: { VoucherItem },
  inject: ['payment', 'vouchers', 'refresh', 'isFailed'],
  // eslint-disable-next-line vue/require-prop-types
  props: ['show'],
  data() {
    return {
      // 折扣详情是我局
      detail: {
        show: false,
        disable: false,
        isLater: false,
        data: {},
      },
      // 当期选择折扣(临时)多个
      curVous: [],
      // 折扣列表
      voucherList: [],
      loading: false,
      // 搜索关键字
      keyword: '',
      // 是否是later，是later就不禁用详情的按钮
      isLater: false,
      SERVICE_MAP: {
        PICK_UP: this.$t('checkout.pickup'),
        DINE_IN: this.$store.state.prefetch.storeInfo.customize.DINE_IN,
        DELIVERY: this.$t('checkout.delivery'),
      },
    };
  },
  computed: {
    filterVoucherList() {
      const { keyword, voucherList } = this;
      return voucherList.filter((it) => {
        const upKey = keyword.toUpperCase();
        const code = it.promoCode?.toUpperCase();
        const name = it.name?.toUpperCase();
        return code?.includes(upKey) || name?.includes(upKey);
      });
    },
    detailInfo() {
      const list = [];
      try {
        const voucher = this.detail.data || {};
        const $n = (v) => this.$n(v, 'currency', 'id-ID');
        const {
          fixAmount,
          maxDiscountAmount,
          promoCode,
          fromDate = new Date(),
          fromTime = '',
          thruDate = new Date(),
          thruTime = '',
          useLimitPerCustomer,
          useLimitPerPromotion,
          minimumTransaction,
          paymentMethodAllowed = '',
          serviceTypeAllowed,
          onlyNewCustomer,
          voucherTypeImg,
          promoEligibility,
        } = voucher;
        const fromStr = `${fromDate} ${fromTime}`.trim().replace(/-/g, '/');
        const thruStr = `${thruDate} ${thruTime}`.trim().replace(/-/g, '/');
        const from = fromStr ? new Date(fromStr) : '';
        const thru = thruStr ? new Date(thruStr) : '';
        const payment = paymentMethodAllowed;
        // 1. code
        list.push({
          key: this.$t('checkout.voucherCode'),
          value: promoCode,
          icon: 'dm-duplicate',
        });
        // 2. from end date
        list.push({
          key: this.$t('checkout.validityPeriod'),
          value: `${formatDate(from, 'dd MMMM yyyy')} - ${formatDate(
            thru,
            'dd MMMM yyyy',
          )}`,
          icon: 'dm-calendar',
        });
        // 3. payment
        payment &&
          list.push({
            key: this.$t('checkout.paymentTypeKey'),
            value: payment,
            icon: 'dm-Cash',
          });
        // 最小交易金额
        minimumTransaction &&
          list.push({
            key: this.$t('checkout.minTransaction'),
            value: $n(minimumTransaction),
            icon: 'dm-Cash',
          });
        // 最大优惠金额
        maxDiscountAmount &&
          list.push({
            key: this.$t('checkout.maxDiscount'),
            value: $n(maxDiscountAmount),
            icon: 'dm-tag',
          });
        // 4. Service type
        serviceTypeAllowed &&
          list.push({
            key: this.$t('checkout.onlyServiceKey'),
            value: this.$t('checkout.onlyServiceValue', {
              v1: serviceTypeAllowed
                .split(',')
                .filter(Boolean)
                .reduce((pre, item) => [...pre, this.SERVICE_MAP[item]], [])
                .filter(Boolean)
                .join(','),
            }),
            icon: 'dm-cube',
          });
        // OtherInfo Laitian
        // 时间字符串
        const timeStr = this.$t('checkout.promoTimeStr', {
          v1: formatDate(from, 'HH:mm a'),
          v2: formatDate(thru, 'HH:mm a'),
        });
        // 每个用户最大使用额度
        const perCustomerStr = useLimitPerCustomer
          ? this.$t('checkout.onlyUseByCustomer', {
              v1: useLimitPerCustomer,
            })
          : '';
        // 限定用户类型
        const promoEligibilityList = {
          LOGGED_IN: this.$t('checkout.promoEligibility_LOGGED_IN'),
          GUEST: this.$t('checkout.promoEligibility_GUEST'),
          ALL: this.$t('checkout.promoEligibility_ALL')
        }
        const promoEligibilityStr = promoEligibilityList[promoEligibility]

        const newCustomerOnly = onlyNewCustomer
          ? this.$t('checkout.newCustomerOnly')
          : '';
        return {
          list,
          timeStr,
          perCustomerStr,
          promoEligibilityStr,
          minimumTransaction,
          paymentMethodAllowed,
          endDate: formatDate(thru, 'dd - M - yyyy'),
          newCustomerOnly,
          avatar: voucherTypeImg
        };
      } catch (error) {
        console.log(error);
        return { list };
      }
    },
    detailBtnDisable() {
      return this.detail?.disable;
    },
    detailBtnText() {
      // if (this.detail?.data?.needClaim) {
      //   return this.$t('order.checkout.claimNow')
      // }
      return this.isChoose(this.detail.data)
        ? this.$t('checkout.uselater')
          : this.$t('checkout.useVoucher');
    },
    isSearch() {
      return this.keyword.trim().length !== 0;
    },
    isNoneBtn() {
      return this.curVous.length === 0;
    },
  },
  watch: {
    show(v) {
      const { vouchers: selecteds } = this;
      const ids = selecteds.filter(Boolean).map((it) => it.id);
      if (v) {
        this.getVoucher().then(() => {
          if (!this.isFailed) {
            this.curVous = this.voucherList.filter((it) => ids.includes(it.id));
            // this.curVous[0] && this.onShowDetail(this.curVous[0], false);
          }
        });
      } else {
        this.voucherList = [];
        this.curVous = [];
      }
    },
  },
  methods: {
    isChoose(data) {
      return this.curVous.findIndex((it) => it.id === data?.id) >= 0;
    },
    onShowDetail(item, disable) {
      this.detail = { show: true, data: item, disable };
    },
    onChoose(data) {
      if (this.detail?.data?.needClaim) {
        this.$emit('claim')
        this.detail.show = false
        return;
      }
      const choose = this.isChoose(data);
      if (choose) {
        this.curVous = this.curVous.filter((it) => it.id !== data.id);
      } else {
        this.curVous.push(data);
      }
      this.detail.show = false;
    },
    useVoucher() {
      this.keyword = '';
      const { curVous, detail } = this;
      const difItems = xorBy(curVous, this.vouchers, 'id');
      // 优惠券数量减少了
      if (curVous.length < this.vouchers.length) {
        const params = { orderId: this.fullDineInOrderId };
        if (!this.isFullDineIn) delete params.orderId;
        const callRemove = this.isFullDineIn ? reqRemoveCoupon : reqDelVoucher;
        useRetry(callRemove, { params }).then((res) => this.refresh());
      }
      // 优惠券有变化
      if (difItems.length !== 0) this.$emit('use', curVous);
      this.$emit('update:show', false);
    },
    getVoucher() {
      this.loading = true;
      const params = {
        serviceType: this.accessStatus,
        paymentMethod: this.payment?.name || '',
      };
      if (this.isFullDineIn) {
        params.orderId = this.fullDineInOrderId;
      }
      return getVoucherList(params)
        .then((res) => {
          // TODO: 临时添加来源于app的优惠券标志
          this.voucherList =
            res?.data.map((it) => ({ ...it, from: 'app' })) || [];
        })
        .finally(() => {
          this.loading = false;
        });
    },
  },
};
</script>

<style scoped lang="scss">
.vpage {
  font-family: GothamOffice;
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 999;
  padding-top: 64px;
  background: #fff;
  &-header {
    height: 64px;
    padding: 0;
    background: $headBg;
    position: absolute;
    top: 0;
    width: 100%;
    display: flex;
    align-items: center;
    font-family: 'Poppins';
    &-back {
      width: 60px;
      text-align: center;
    }
    &-icon {
      width: 24px;
      height: 24px;
      stroke: $headColor;
    }
    &-title {
      font-weight: bold;
      font-size: 24px;
      padding-left: 5px;
      color: $headColor;
      font-family: GothamOffice;
    }
  }
  &-main {
    height: 100%;
    position: relative;
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    &-searchbar {
      padding: 16px;
      :deep(.q-field__control) {
        height: 46px;
        line-height: 46px;
        border-radius: 6px;
      }
    }
    &-body {
      flex: 1;
      overflow: auto;
      white-space: break-word;
      padding: 0 16px;
      &-nodata {
        font-size: 14px;
        text-align: center;
        color: $dark;
        padding: 16px;
      }
    }
    &-footer {
      box-shadow: 1px 0px 8px rgba(0, 0, 0, 0.15);
      padding: 16px;
      .footer-btn {
        text-align: center;
        background: $primary;
        color: #fff;
        font-weight: bold;
        height: 40px;
        line-height: 40px;
        border-radius: 8px;
        width: 100%;
        &.none {
          color: $dark !important;
          background: #fff !important;
          border: 1px solid #d1d5db;
        }
      }
    }
  }
}
// 详情Dialog弹窗样式
.detail {
  display: flex;
  flex-direction: column;
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 999;
  background: #fff;
  &-head {
    padding: 16px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    height: 48px;
    width: 100%;
    background: #fff;
    &-title {
      font-size: 14px;
      font-weight: bold;
    }
    &-close {
      width: 16px;
      height: 16px;
    }
  }
  &-main {
    padding: 16px;
    padding-bottom: 48px;
    border-radius: 6px !important;
    flex: 1;
    overflow: auto;
    &-card {
      display: flex;
      box-shadow: 0px 2px 20px rgba(0, 0, 0, 0.15);
      border-radius: 8px;
      overflow: hidden;
      .card-avatar {
        min-width: 110px;
        min-height: 110px;
        display: flex;
        justify-content: center;
        align-items: center;
        background: #ededee;
        .iconfont {
          font-size: 60px;
        }
      }
      .card-info {
        margin-left: 10px;
        padding: 8px;
        flex: 1;
        display: flex;
        flex-direction: column;
        & > span + span {
          margin-top: 6px;
        }
        .name {
          color: $font-color-gray-deep;
          margin-bottom: 4px;
        }
        .text {
          color: $grayFont;
          font-size: 12px;
        }
      }
    }
    &-list {
      list-style: none;
      padding: 0;
      color: $dark;
      .list-item + .list-item {
        margin-top: 16px;
      }
      .list-item {
        position: relative;
        word-break: break-word;
        display: flex;
        color: $font-color-gray-deep;
        p {
          margin: 0;
        }
        .iconfont {
          margin-right: 6px;
          align-self: flex-start;
          color: $grayFont;
        }
        .key {
          color: $font-color-gray-deep;
          line-height: 1.6;
        }
        .value {
          &.option {
            position: relative;
            padding-left: 16px;
            &::before {
              content: '';
              width: 5px;
              height: 5px;
              border-radius: 50%;
              background: $font-color-gray-deep;
              position: absolute;
              transform: translate(-12px, 9px);
            }
          }
        }
      }
    }
  }
  &-footer {
    padding: 24px 16px 16px;
    color: #fff;
    background: #fff;
    &-btn {
      border-radius: 8px;
      font-weight: bolder !important;
      font-size: 16px;
      line-height: 40px;
      text-align: center;
    }
    .danger {
      background: $negative;
    }
    .normal {
      background: $primary;
    }
    &-btn.disable {
      color: #9ca3af !important;
      background: #d1d5db !important;
      pointer-events: none;
    }
  }
}
</style>
